import { SCHOOL_PROPERTIES } from 'src/config/constants.ts'

export default function schoolYearChangeEnabled({ to, store }) {
  // The `users-compare/:type` routes are shared with the "User Compare" feature (type `same-year`),
  // which must stay available when the school year change is disabled.
  if (to.params.type === 'same-year') return

  const user = store.getters['users/me']
  if (!user) return

  const isEnabled = user.school?.properties?.[SCHOOL_PROPERTIES.SCHOOL_PROPERTY_SCHOOLYEAR_CHANGE] !== false

  if (isEnabled) return

  return { name: 'school-year-change-validation', params: to.params }
}
